import {NzDrawerRef} from 'ng-zorro-antd/drawer';
import {FormGroup} from '@angular/forms';
import {Store} from '@ngxs/store';
import {Component, Input, OnDestroy, OnInit} from '@angular/core';
import {Subscription} from 'rxjs';
import {ValidatableFormComponent} from '../../../../../shared/components/validatable-form';
import {IconCode} from '../../../../../../enums/icon-code.enum';
import {DictionaryItem} from '../../../../../../models/dictionary.model';
import {PolicyPgState} from '../../../../../../state/policy-pg/policy-pg.state';
import {PolicyPgActions} from '../../../../../../state/policy-pg/policy-pg.actions';
import {PgTerminationRequest} from '../../../../../../models/policy.model';


@Component({
    selector: 'app-policy-pg-termination-aside',
    templateUrl: './policy-pg-termination-aside.component.html',
})
export class PolicyPgTerminationAsideComponent extends ValidatableFormComponent implements OnInit, OnDestroy {
    @Input() terminationReasons: DictionaryItem[];
    @Input() policyId: number;
    amendmentIcon = IconCode.DELETE;
    public formGroup: FormGroup;
    protected errors = {};
    subscriptions: Subscription = new Subscription();
    ibanMask = `00${' 0000'.repeat(6)}`;

    constructor(private readonly store: Store, private readonly drawerRef: NzDrawerRef) {
        super(store.select(PolicyPgState.formErrors));
    }

    ngOnInit(): void {

        this.formGroup = new FormGroup({
            effectiveDate: this.createFormControl(null, 'effectiveDate', true),
            reason: this.createFormControl(undefined, 'reason'),
            refundBankAccount: this.createFormControl(null, 'refundBankAccount'),
        });

        this.subscriptions.add(
            this.formGroup.get('reason')?.valueChanges?.subscribe(changes => {
                if (changes?.code === 'WITHDRAWAL' || changes?.code === 'TOTAL_LOSS_PARTIAL_SU') {
                    this.formGroup.get('effectiveDate').enable();
                } else {
                    this.formGroup.get('effectiveDate').setValue(null);
                    this.formGroup.get('effectiveDate').disable();
                }
            })
        );
    }

    ngOnDestroy() {
        this.subscriptions.unsubscribe();
        super.ngOnDestroy();
    }

    submit() {
        const formValue = this.formGroup.getRawValue();
        const payload: PgTerminationRequest = {
            effectiveDate: formValue.effectiveDate || null,
            reason: formValue.reason || null,
            refundBankAccount: formValue.refundBankAccount || null,
        };
        this.store.dispatch(new PolicyPgActions.TerminatePolicy(this.policyId, payload));
    }

    close() {
        this.drawerRef.close();
    }
}
